import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-waiting-modal',
  templateUrl: './waiting-modal.component.html',
  styleUrls: ['./waiting-modal.component.css']
})
export class WaitingModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
